import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTeacherRosterDetailsSuccess,
  deleteRosteredStudentSuccess,
} from "../actions/rosterActions";
import {
  startSpinner,
  stopSpinner,
  showPopUp,
} from "../../../redux/authActions";
import * as actions from "../actions/actionTypes";
import { doGet, doPost, doDelete } from "../../../utils/ajaxHelper";
import { urls } from "../../../HOC/withApiService";

export function* getTeacherRosteringDetails(action) {
  try {
    yield put(startSpinner());
    const fetchURL = `${urls.Rostering.getTeacherRosteringDetails}?userPuid=${action.payload.user_puid}`;
    const studentsData = yield call(doGet, fetchURL);
    if ([401, "401"].includes(studentsData?.status)) {
      yield put(showPopUp(401));
    } else
      yield put(fetchTeacherRosterDetailsSuccess(studentsData?.data?.data));
  } catch (error) {
    yield put(showPopUp(501));
    yield put(fetchTeacherRosterDetailsSuccess(null));
  } finally {
    yield put(stopSpinner());
  }
}

export function* deleteRosteredStudentData(action) {
  try {
    yield put(startSpinner());
    const deleteUrl = `${urls.Rostering.deleteStudent}?userPuid=${action.payload.selected_user_puid}&permanentDelete=true&logged_in_userPuid=${action.payload.loggedin_user_puid}`;
    const response = yield call(doDelete, deleteUrl);
    if ([401, "401"].includes(response?.status)) {
      yield put(showPopUp(401));
    } else {
      yield put(
        deleteRosteredStudentSuccess(action.payload.selected_user_puid)
      );
      yield put(showPopUp(200));
    }
  } catch (error) {
    yield put(showPopUp(501));
  } finally {
    yield put(stopSpinner());
  }
}

export function* callGetTeacherRosteringDetails() {
  yield takeLatest(
    actions.GET_TEACHER_ROSTER_DETAILS,
    getTeacherRosteringDetails
  );
}

export function* callDeleteRosteredStudent() {
  yield takeLatest(actions.DELETE_ROSTERED_STUDENT, deleteRosteredStudentData);
}

export function* RosteringTabSaga() {
  yield all([callGetTeacherRosteringDetails()]);
}
